export class InputEventHelper {
  static isSetaEsquerda(event: any): boolean {
    return event && event.keyCode == 37;
  }

  static isSetaDireita(event: any): boolean {
    return event && event.keyCode == 39;
  }

  static isSetaCima(event: any): boolean {
    return event && event.keyCode == 38;
  }

  static isSetaBaixo(event: any): boolean {
    return event && event.keyCode == 40;
  }

  static isTab(event: any): boolean {
    return event && event.keyCode == 9;
  }
}
